<template>
  <div class="header" v-click-away="onClickAway">
    <div class="header-main">
      <div class="header-main__wrapper">
        <div class="header-main__menu">
          <input
            type="checkbox"
            id="menu"
            @click="isOpened = !isOpened"
            :checked="isOpened"
          />
          <label class="menu-label" for="menu">
            <div class="header-main__menu-burger">
              <div></div>
            </div>
          </label>
        </div>
        <a href="/customer" class="header-main__logo">
          <img
            :src="require(`../assets/images/big-logo.svg`)"
            alt="BiletDV Logo"
            class="header-main__logo-svg__desc"
          />
          <svg
            width="127"
            height="31"
            viewBox="0 0 127 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="header-main__logo-svg__mob"
          >
            <g filter="url(#filter0_d)">
              <path
                d="M56.6028 3.22931C56.0402 3.22931 55.5782 3.71839 55.5782 4.31396V12.949H58.9084V5.74175H68.1755L68.1754 8.5883H61.5972L61.5973 11.1454H66.4163L66.4386 12.949H71.5428V4.31396C71.5428 3.71839 71.0809 3.22931 70.5183 3.22931H56.6028Z"
                fill="white"
              />
              <path
                d="M73.648 3.24213C73.0854 3.24213 72.6421 3.7312 72.6421 4.32677L72.6409 12.949H79.2727V8.60111H74.7453L74.7574 5.75457H86.4387V8.60111H81.9537V12.949H88.5879V4.32679C88.5879 3.73122 88.1445 3.24214 87.5819 3.24214L73.648 3.24213Z"
                fill="white"
              />
              <path
                d="M90.7118 3.24213C90.1492 3.24213 89.6872 3.7312 89.6872 4.32677V12.949H92.3884L92.3753 5.75457H97.0697C98.8849 5.75457 100.329 6.53315 101.386 7.93569C102.311 9.16707 102.838 11.0858 102.951 12.949H105.652V4.32677C105.652 3.7312 105.19 3.24213 104.627 3.24213H90.7118Z"
                fill="white"
              />
              <path
                d="M22.4939 3.22931C21.9313 3.22931 21.4694 3.71839 21.4694 4.31396L21.4729 12.949H28.2318V5.81275H30.6908V12.949H37.4343V4.31396C37.4343 3.71839 36.9723 3.22931 36.4097 3.22931H22.4939Z"
                fill="white"
              />
              <path
                d="M39.5577 3.22927C38.9951 3.22927 38.5332 3.71835 38.5332 4.31392L38.4982 12.9489H42.0935L42.1205 5.74172H44.8119L44.7769 12.9489H54.4629L54.4979 4.3139C54.5002 3.71833 54.0359 3.22925 53.4733 3.22925L39.5577 3.22927Z"
                fill="white"
              />
              <path
                d="M107.757 3.22931C107.194 3.22931 106.751 3.71839 106.751 4.31396V12.949H110.967L108.704 5.73459H111.466L113.73 12.949L115.666 12.9428L117.928 5.7346H120.69L118.421 12.949H122.716V4.31398C122.716 3.71841 122.254 3.22933 121.691 3.22933L107.757 3.22931Z"
                fill="white"
              />
              <path
                d="M5.30878 3.16318C4.7462 3.16318 4.28421 3.65226 4.28421 4.24783L4.32189 12.9489H7.45149L7.41381 5.74661H12.1641C13.3847 5.74661 14.334 6.12525 15.0329 6.8707C15.7311 7.61536 16.0947 8.49255 16.0947 9.5133C16.0947 10.8015 16.1312 12.2563 15.0738 12.9489H20.2747L20.2489 4.24783C20.2471 3.65226 19.7869 3.16318 19.2243 3.16318H5.30878ZM10.151 8.58829V11.1454H11.8462C12.3685 11.1454 12.9986 10.5952 13.015 9.92795C13.0115 9.38972 12.502 8.58829 11.8462 8.58829H10.151Z"
                fill="white"
              />
              <path
                d="M96.2053 8.46029C95.9099 8.46319 95.6102 8.4838 95.0131 8.4838V12.983H100.378C100.364 10.3199 98.961 8.56165 97.3789 8.50731C96.7911 8.47211 96.5006 8.45737 96.2053 8.46029Z"
                fill="white"
              />
              <path
                d="M95.0131 13.0122V17.1399H97.3789V17.1219C98.9067 17.2121 100.438 15.2057 100.434 13.0122H95.0131Z"
                fill="white"
              />
              <path
                d="M55.5783 13.0011V21.7519C55.5783 22.3475 56.0403 22.8365 56.6029 22.8365H70.5184C71.081 22.8365 71.543 22.3475 71.543 21.7519V13.0011H66.4201L66.4166 13.833H61.5976V17.2018H68.1758L68.1901 20.0559H58.9317V13.0011H55.5783Z"
                fill="white"
              />
              <path
                d="M72.6422 13.0011V21.7519C72.6422 22.3475 73.0855 22.8365 73.6481 22.8365H87.5823C88.1449 22.8365 88.5882 22.3475 88.5882 21.7519V13.0011H81.954V20.0451H79.2731V13.0011H72.6422Z"
                fill="white"
              />
              <path
                d="M89.6873 13.0446V21.7522C89.6873 22.3477 90.1493 22.8368 90.7119 22.8368H104.627C105.19 22.8368 105.652 22.3477 105.652 21.7522V13.0446H102.969V13.1786C102.969 15.5104 101.854 17.4089 101.349 18.0643C100.279 19.3935 98.7669 20.0562 96.7848 20.0562L92.3754 20.0452V13.0446H89.6873Z"
                fill="white"
              />
              <path
                d="M21.4727 13.0011L21.4692 21.7519C21.4689 22.3475 21.9314 22.8365 22.494 22.8365H36.4095C36.9721 22.8365 37.4341 22.3475 37.4341 21.7519V13.0011H30.7256L30.6906 20.0559H28.2316L28.2666 13.0011H21.4727Z"
                fill="white"
              />
              <path
                d="M38.5355 13.0011L38.5705 21.7519C38.5729 22.3474 39.0139 22.8365 39.5765 22.8365H53.5106C54.0732 22.8365 54.5352 22.3475 54.5352 21.7519L54.5003 13.0011H44.777L44.812 17.2021L50.9066 17.2018V20.0449L42.1286 20.0561L42.0936 13.0011H38.5355Z"
                fill="white"
              />
              <path
                d="M106.751 13.0014V21.7522C106.751 22.3477 107.194 22.8368 107.757 22.8368H121.691C122.254 22.8368 122.716 22.3477 122.716 21.7522V13.0014L118.318 12.9953L116.079 20.1618L113.319 20.1557L111.068 12.983L106.751 13.0014ZM113.832 12.983L114.698 15.7166L115.569 12.983H113.832Z"
                fill="white"
              />
              <path
                d="M4.2843 13.0011V21.7518C4.2843 22.3474 4.74629 22.8365 5.30887 22.8365H19.2244C19.787 22.8365 20.249 22.3474 20.249 21.7518L20.2371 13.0011H15.9222C16.0517 13.0838 16.344 13.374 16.4792 13.5634C16.7044 13.9726 17.0262 15.0266 17.0262 15.6384C17.0262 16.9423 16.6708 18.0151 15.9644 18.8331C15.2565 19.6519 14.2118 20.0558 12.8348 20.0558H7.45113V13.0011H4.2843Z"
                fill="white"
              />
              <path
                d="M10.1497 17.2021V13.8333H12.3546C12.9418 13.8333 13.4083 14.0186 13.76 14.3854C14.3978 15.3037 14.2439 16.1236 13.7324 16.7035C13.3651 17.0341 12.7981 17.2021 11.9225 17.2021H10.1497Z"
                fill="white"
              />
            </g>
            <defs>
              <filter
                id="filter0_d"
                x="-1"
                y="0"
                width="129"
                height="34"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dy="4" />
                <feGaussianBlur stdDeviation="2" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow"
                  result="shape"
                />
              </filter>
            </defs>
          </svg>
        </a>
        <div class="header-main__menu-mob"></div>
        <div class="header-main__menu-desc">
          <a
            class="header-main__menu-desc__item"
            href="https://www.biletdv.ru/link/18"
            >Авиабилеты</a
          >
          <a
            class="header-main__menu-desc__item"
            href="https://www.biletdv.ru/link/19"
            >Ж/д билеты</a
          >
          <a
            class="header-main__menu-desc__item"
            href="https://www.biletdv.ru/link/20"
            >Отели</a
          >
          <a
            class="header-main__menu-desc__item"
            href="https://www.biletdv.ru/link/21"
            >Страхование</a
          >
        </div>
      </div>
    </div>
    <div class="header-opened" :class="{ menuopened: isOpened }">
      <router-link
        to="/orders"
        active-link="active"
        class="header-opened__btn"
        @click="isOpened = !isOpened"
        >Мои заказы</router-link
      >
      <router-link
        to="/offers"
        active-link="active"
        class="header-opened__btn"
        @click="isOpened = !isOpened"
        >Заявления на возврат</router-link
      >
       <router-link
        to="/issues"
        active-link="active"
        class="header-opened__btn"
        @click="isOpened = !isOpened"
        >Обращения в поддержку</router-link
      >
      <router-link
        to="/profile"
        active-link="active"
        class="header-opened__btn"
        @click="isOpened = !isOpened"
        >Профиль</router-link
      >
      <a
        href="https://www.biletdv.ru/"
        class="header-opened__btn"
        @click="isOpened = !isOpened"
        >Авиабилеты</a
      >
      <router-link
        to="/contacts"
        active-link="active"
        class="header-opened__btn p-ripple"
        @click="isOpened = !isOpened"
        v-ripple
        >Контакты</router-link
      >
      <a
        href="https://www.biletdv.ru/Pages/HelpDesk#AviaTickets"
        class="header-opened__btn"
        @click="isOpened = !isOpened"
        >Часто задаваемые вопросы</a
      >
      <div class="logout-btn__wrapper" @click="logout">
        <button class="logout-btn p-ripple" type="button" v-ripple>
          <div class="logout-btn__text">Выйти</div>
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "@vue/runtime-core";
import Ripple from "primevue/ripple";
import store from "../store/index";
import { mapActions, mapGetters } from "vuex";
import axios from "axios";
import { useRouter, useRoute } from "vue-router";
import router from "../router";

const axioCred = axios.create({
  withCredentials: true,
});

export default defineComponent({
  name: "HeaderItem",
  setup() {
    const router = useRouter();
    const route = useRoute();
    return {
      router,
      route,
    };
  },
  data() {
    return {
      isOpened: false,
    };
  },
  methods: {
    ...mapActions("auth", {
      actionLogout: "logout",
    }),
    // logout() {
    //   this.actionLogout();
    //   this.$router.push("/login");
    //   this.isOpened = !this.isOpened;
    // },
    logout() {
      axioCred.post(`https://www.biletdv.ru/customer/IBEServices/Logout`).then((res) => {
        if (res.status == 200) {
          this.isOpened = !this.isOpened;
          this.actionLogout();
          router.push("/login");
        }
      });
    },
    menuHandler() {
      this.isOpened = true;
    },
    onClickAway() {
      this.isOpened = false;
    },
    // authState() {
    //   if (store.module.auth.loginStatus == )
    // }
  },
  directives: {
    ripple: Ripple,
  },
});
</script>

<style lang="scss" scoped>
@media screen and (max-width: 767px) {
  .header-opened__btn:hover {
    background-color: #ececec;
    background: linear-gradient(
      to left,
      #ffffff 15%,
      #ececec 90%,
      rgb(255, 255, 255) 100%
    );
  }

  .header {
    position: relative;
    max-width: 100%;
    background-color: #e9e9e9;
    display: flex;
    flex-direction: column;
  }

  .header-main {
    background-color: #2196f3;
  }

  .header-main__wrapper {
    max-width: 100%;
    width: auto;
    min-height: 64px;
    display: flex;
    margin: 0 25px;
    justify-content: space-between;
    align-items: center;
  }

  .header-main__menu {
    box-sizing: border-box;
  }

  .header-main__logo-mob {
    text-decoration: none;
    outline: none;
    text-align: center;
  }
  .header-main__logo-svg__desc {
    display: none;
  }

  .header-main__logo-svg__mob {
    display: block;
  }

  .header-main__menu-desc {
    display: none;
  }

  .header-main__menu-mob {
    width: 25px;
  }

  .header-main__profile {
    width: 25px;
    visibility: hidden;
  }
  .header-opened {
    width: 100%;
    display: block;
    background: #fff;
    visibility: hidden;
    top: 64px;
    left: 0;
    position: absolute;
    z-index: 5;
    opacity: 0;
    transition: visibility 0.3s, opacity 0.3s;
    min-height: 300px;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 2px;
    padding: 10px 0 10px 0;
  }

  .menuopened {
    visibility: visible;
    opacity: 1;
  }

  .header-opened__btn {
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    display: block;
    padding: 8px 25px 10px;
    color: #000;
    text-decoration: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }

  .logout-btn__wrapper {
    margin-left: 25px;
    margin-top: 50px;
  }

  .logout-btn {
    color: #fff;
    font-size: 14px;
    line-height: 17px;
    background-color: #2196f3;
    padding: 6px 20px;
    border-radius: 3px;
    border: none;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  }

  .active {
    color: #5ac293;
  }

  #menu {
    position: absolute;
    left: -999px;
    top: -999px;
  }

  .menu-label {
    box-sizing: border-box;
  }

  .header-main__menu-burger {
    // transform: translate(-50%, -50%);
    width: 25px;
  }

  .header-main__menu-burger:before,
  .header-main__menu-burger:after,
  .header-main__menu-burger div {
    background: #fff;
    content: "";
    display: block;
    height: 3px;
    border-radius: 2px;
    margin: 3px 0;
    transition: 0.5s;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  }

  #menu:checked + .menu-label {
    .header-main__menu-burger:before {
      transform: translateY(7px) rotate(135deg);
    }
    .header-main__menu-burger:after {
      transform: translateY(-5px) rotate(-135deg);
    }
    .header-main__menu-burger div {
      transform: scale(0);
    }
    .header-opened {
      transition: visibility 0.3s, opacity 0.3s;
    }
  }
}

@media screen and (min-width: 768px) and (max-width: 1024px) {
  .header-opened__btn:hover {
    background-color: #ececec;
    background: linear-gradient(
      to left,
      #ffffff 15%,
      #ececec 90%,
      rgb(255, 255, 255) 100%
    );
  }

  .header {
    position: relative;
    max-width: 100%;
    background-color: #e9e9e9;
    display: flex;
    flex-direction: column;
  }

  .header-main {
    background-color: #2196f3;
  }

  .header-main__wrapper {
    max-width: 100%;
    width: auto;
    min-height: 64px;
    display: flex;
    margin: 0 25px;
    justify-content: space-between;
    align-items: center;
  }

  .header-main__menu {
    box-sizing: border-box;
  }

  .header-main__logo-mob {
    text-decoration: none;
    outline: none;
    text-align: center;
  }
  .header-main__logo-svg__desc {
    display: none;
  }

  .header-main__logo-svg__mob {
    display: block;
  }

  .header-main__menu-desc {
    display: none;
  }

  .header-main__menu-mob {
    width: 25px;
  }

  .header-main__profile {
    width: 25px;
    visibility: hidden;
  }
  .header-opened {
    width: 100%;
    display: block;
    background: #fff;
    visibility: hidden;
    top: 64px;
    left: 0;
    position: absolute;
    z-index: 5;
    opacity: 0;
    transition: visibility 0.3s, opacity 0.3s;
    min-height: 300px;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 2px;
    padding: 10px 0 10px 0;
  }

  .menuopened {
    visibility: visible;
    opacity: 1;
  }

  .header-opened__btn {
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    display: block;
    padding: 8px 25px 10px;
    color: #000;
    text-decoration: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }

  .logout-btn__wrapper {
    margin-left: 25px;
    margin-top: 50px;
  }

  .logout-btn {
    color: #fff;
    font-size: 18px;
    background-color: #2196f3;
    padding: 6px 20px;
    border-radius: 3px;
    border: none;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  }

  .active {
    color: #5ac293;
  }

  #menu {
    position: absolute;
    left: -999px;
    top: -999px;
  }

  .menu-label {
    box-sizing: border-box;
  }

  .header-main__menu-burger {
    // transform: translate(-50%, -50%);
    width: 25px;
  }

  .header-main__menu-burger:before,
  .header-main__menu-burger:after,
  .header-main__menu-burger div {
    background: #fff;
    content: "";
    display: block;
    height: 3px;
    border-radius: 2px;
    margin: 3px 0;
    transition: 0.5s;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  }

  #menu:checked + .menu-label {
    .header-main__menu-burger:before {
      transform: translateY(7px) rotate(135deg);
    }
    .header-main__menu-burger:after {
      transform: translateY(-5px) rotate(-135deg);
    }
    .header-main__menu-burger div {
      transform: scale(0);
    }
    .header-opened {
      transition: visibility 0.3s, opacity 0.3s;
    }
  }
}

@media screen and (min-width: 1025px) {
  .header-opened__btn:hover {
    background-color: #ececec;
    background: linear-gradient(
      to left,
      #ffffff 15%,
      #ececec 90%,
      rgb(255, 255, 255) 100%
    );
  }

  .header {
    position: relative;
    max-width: 100%;
    background-color: #e9e9e9;
    display: flex;
    flex-direction: column;
  }

  .header-main {
    background-color: #2196f3;
    padding: 0 10px;
  }

  .header-main__wrapper {
    max-width: 1260px;
    width: auto;
    min-height: 64px;
    display: flex;
    align-items: center;
    margin-left: auto;
    margin-right: auto;
  }

  .header-main__menu {
    display: none;
  }

  .header-main__logo-svg__mob {
    display: none;
  }

  .header-main__logo-svg__desc {
    margin-top: 5px;
    width: 90%;
    height: 90%;
  }

  .header-main__menu-desc {
    display: flex;
  }

  .header-main__menu-desc__item {
    color: #fff;
    font-size: 18px;
    margin-left: 15px;
    text-decoration: none;
  }

  .header-main__menu-desc__item:hover {
    text-decoration: underline;
  }

  .header-opened {
    width: 100%;
    display: block;
    background: #fff;
    visibility: hidden;
    top: 64px;
    left: 0;
    position: absolute;
    z-index: 5;
    opacity: 0;
    transition: visibility 0.3s, opacity 0.3s;
    min-height: 300px;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 2px;
    padding: 10px 0 10px 0;
  }

  .menuopened {
    visibility: visible;
    opacity: 1;
  }

  .header-opened__btn {
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    display: block;
    padding: 8px 25px 10px;
    color: #000;
    text-decoration: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }

  .logout-btn__wrapper {
    margin-left: 25px;
    margin-top: 50px;
  }

  .logout-btn {
    color: #fff;
    font-size: 14px;
    line-height: 17px;
    background-color: #2196f3;
    padding: 6px 20px;
    border-radius: 6px;
    border: none;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  }

  .active {
    color: #5ac293;
  }

  #menu {
    position: absolute;
    left: -999px;
    top: -999px;
  }

  .menu-label {
    box-sizing: border-box;
  }

  .header-main__menu-burger {
    // transform: translate(-50%, -50%);
    width: 25px;
  }

  .header-main__menu-burger:before,
  .header-main__menu-burger:after,
  .header-main__menu-burger div {
    background: #fff;
    content: "";
    display: block;
    height: 3px;
    border-radius: 2px;
    margin: 3px 0;
    transition: 0.5s;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  }

  #menu:checked + .menu-label {
    .header-main__menu-burger:before {
      transform: translateY(7px) rotate(135deg);
    }
    .header-main__menu-burger:after {
      transform: translateY(-5px) rotate(-135deg);
    }
    .header-main__menu-burger div {
      transform: scale(0);
    }
    .header-opened {
      transition: visibility 0.3s, opacity 0.3s;
    }
  }
}
</style>
